<mat-card>
  <mat-card-header class="border-bottom">
    <mat-card-title id="formTitle">
      Adicionar regra fiscal
    </mat-card-title>
  </mat-card-header>
  <mat-card-content id="cardContent">
    <div class="row-m-0 mt-2">
      <div class="mt-2 col-md-12">
        <span class="p-float-label">
          <input
            id="inputtext-descricao"
            class="input-filters"
            pInputText
            [formControl]="form.get('descricao')"
            type="text"
            autocomplete="off"
          />
          <label for="inputtext-descricao">Descrição *</label>
        </span>
        <small
          class="p-error"
          *ngIf="
            form.get('descricao').touched &&
            form.get('descricao').hasError('required')
          "
          [innerHTML]="'A descrição é obrigatória'"
        >
        </small>
        <small
          class="p-error"
          *ngIf="
            form.get('descricao').touched &&
            form.get('descricao').hasError('maxlength')
          "
          [innerHTML]="'O campo não pode possuir mais que 100 caracteres'"
        >
        </small>
        <small
          class="p-error"
          *ngIf="
            form.get('descricao').touched &&
            form.get('descricao').hasError('isEmptyValue')
          "
          [innerHTML]="'Valor inválido: remova os espaços em branco!'"
        >
        </small>
      </div>
      <!-- select mod_bc e mod_bc_st -->
      <div class="content-allFormFields justify-content-between mb-2">
        <div class="mt-2 col-md-4">
          <mat-form-field style="width: 100% !important;" appearance="outline">
            <mat-label>Modalidade Base de Cálculo</mat-label>
            <mat-select [formControl]="form.controls.mod_bc">
              <mat-option *ngFor="let i of modBcOptions" [value]="i.value">{{
                i.viewValue
              }}</mat-option>
            </mat-select>
          </mat-form-field>
          <small
            class="p-error"
            *ngIf="
              form.get('mod_bc').touched &&
              form.get('mod_bc').hasError('required')
            "
            [innerHTML]="'A modalidade de base de cálculo é obrigatória'"
          >
          </small>
        </div>
        <div class="mt-2 col-md-4">
          <mat-form-field style="width: 100% !important;" appearance="outline">
            <mat-label>Modalidade Base de Cálculo ST</mat-label>
            <mat-select [formControl]="form.controls.mod_bc_st">
              <mat-option *ngFor="let i of modBcStOptions" [value]="i.value">{{
                i.viewValue
              }}</mat-option>
            </mat-select>
          </mat-form-field>
          <small
            class="p-error"
            *ngIf="
              form.get('mod_bc_st').touched &&
              form.get('mod_bc_st').hasError('required')
            "
            [innerHTML]="'A modalidade de base de cálculo ST é obrigatória'"
          >
          </small>
        </div>
        <div class="mt-2 col-md-4">
          <mat-form-field style="width: 100% !important;" appearance="outline">
            <mat-label>Usar para</mat-label>
            <mat-select [formControl]="form.controls.modelo" [disabled]="true">
              <mat-option *ngFor="let i of tiposModelo" [value]="i.value">{{
                i.viewValue
              }}</mat-option>
            </mat-select>
          </mat-form-field>
          <small
            class="p-error"
            *ngIf="
              form.get('modelo').touched &&
              form.get('modelo').hasError('required')
            "
            [innerHTML]="'O modelo da nota é obrigatório'"
          >
          </small>
        </div>
      </div>
      <div class="mt-2 col-md-12 mt-2" *ngIf="showTipoIpi">
        <span class="p-float-label">
          <p-dropdown
            [(ngModel)]="form.value.tipo_ipi"
            [formControl]="form.get('tipo_ipi')"
            [options]="tiposIpi"
            optionLabel="viewValue"
            id="float-input"
          >
          </p-dropdown>
          <label for="float-input">Tipo IPI *</label>
        </span>
        <small
          class="p-error"
          *ngIf="
            form.get('tipo_ipi').touched &&
            form.get('tipo_ipi').hasError('required')
          "
          [innerHTML]="'O tipo IPI é obrigatório'"
        >
        </small>
        <small
          class="p-error"
          *ngIf="
            form.get('tipo_ipi').touched &&
            form.get('tipo_ipi').hasError('maxlength')
          "
          [innerHTML]="'O campo deve possuir até 6 caracteres'"
        >
        </small>
      </div>
      <!-- autocompletes -->
      <div class="mt-2 col-md-12">
        <fast-autocomplete
          #input
          required
          (clearSelection)="form.get('cstipi').reset()"
          [controlIsEnabled]="!isCRT1"
          [autoFirst]="false"
          [control]="form.get('cstipi')"
          [entityService]="cstIpiService"
          [readonly]="isCRT1"
          displayField="cst"
          [displayWithEntityFn]="cstIpiDisplay"
          placeholder="CST IPI"
          [initDataWithEmpty]="true"
          autocomplete="off"
          [actionState]="false"
          [action_order]="'cst'"
          [messages]="{
            typeIs: 'Valor inválido',
            isEmptyValue: 'Inválido: remova os espaços em branco!'
          }"
        ></fast-autocomplete>
      </div>
      <div class="mt-2 col-md-12">
        <fast-autocomplete
          #input
          required
          [autoFirst]="false"
          [control]="form.get('csticms')"
          [entityService]="cstIcmsService"
          displayField="cstcsosn"
          [action_order]="'cstcsosn'"
          (clearSelection)="form.get('csticms').reset()"
          [searchFieldPath]="'modelo'"
          [useChange]="true"
          [searchField]="
            form.value.modelo && form.value.modelo === 'NFE' ? 55 : 65
          "
          placeholder="CST ICMS"
          [initDataWithEmpty]="true"
          [displayWithEntityFn]="cstIcmsdisplay"
          autocomplete="off"
          [messages]="{
            required: 'CST ICMS é obrigatório',
            typeIs: 'Valor inválido',
            isEmptyValue: 'Inválido: remova os espaços em branco!'
          }"
          [actionState]="false"
        ></fast-autocomplete>
      </div>
      <div class="mt-2 col-md-12">
        <fast-autocomplete
          #input
          required
          [autoFirst]="false"
          (clearSelection)="form.get('cstcofins').reset()"
          [control]="form.get('cstcofins')"
          [entityService]="cstCofinsService"
          displayField="cst"
          [action_order]="'cst'"
          placeholder="CST COFINS"
          [displayWithEntityFn]="cstCofinsDisplay"
          [messages]="{
            required: 'CST COFINS é obrigatório',
            typeIs: 'Valor inválido',
            isEmptyValue: 'Inválido: remova os espaços em branco!'
          }"
          [initDataWithEmpty]="true"
          autocomplete="off"
          [actionState]="false"
        ></fast-autocomplete>
      </div>
      <div class="mt-2 col-md-12">
        <fast-autocomplete
          #input
          required
          [autoFirst]="false"
          [control]="form.get('cstpis')"
          [entityService]="cstPisService"
          (clearSelection)="form.get('cstpis').reset()"
          displayField="cst"
          [action_order]="'cst'"
          [displayWithEntityFn]="cstPisDisplay"
          placeholder="CST PIS"
          [messages]="{
            required: 'CST PIS é obrigatório',
            typeIs: 'Valor inválido',
            isEmptyValue: 'Inválido: remova os espaços em branco!'
          }"
          [initDataWithEmpty]="true"
          autocomplete="off"
          [actionState]="false"
        ></fast-autocomplete>
      </div>
      <div class="mt-2 col-md-12">
        <fast-autocomplete
          #input
          required
          [autoFirst]="false"
          (clearSelection)="form.get('cfop').reset()"
          [control]="form.get('cfop')"
          [entityService]="cfopService"
          [searchFieldPath]="'modelo'"
          [useChange]="true"
          [searchField]="
            form.value.modelo && form.value.modelo === 'NFE' ? 55 : 65
          "
          displayField="cfop"
          [value_order]="'cfop'"
          [displayWithEntityFn]="cfopDisplay"
          placeholder="CFOP"
          [initDataWithEmpty]="true"
          [messages]="{
            required: 'CFOP é obrigatório',
            typeIs: 'Valor inválido',
            isEmptyValue: 'Inválido: remova os espaços em branco!'
          }"
          autocomplete="off"
          [actionState]="false"
          [pageValue]="'0'"
          [pageSizeValue]="'10'"
        ></fast-autocomplete>
      </div>
      <!-- checkboxs -->
      <div class="row ml-2 mt-2 col-md-12 mt-2" *ngIf="!isCRT1 || is900">
        <!-- <mat-checkbox
          color="primary"
          [formControl]="form.get('indice_difal')"
          class="mt-2 col-md-4"
        >
          Indice difal
        </mat-checkbox>
        <mat-checkbox
          color="primary"
          [formControl]="form.get('difal_base_dupla')"
          class="mt-2 col-md-4"
        >
          Difal base dupla
        </mat-checkbox> -->
        <mat-checkbox
          color="primary"
          [formControl]="form.get('icms_sob_pis_cofins')"
          class="mt-2 col-md-4"
        >
          ICMS sob PIS/COFINS
        </mat-checkbox>
        <!-- <mat-checkbox
          color="primary"
          [formControl]="form.get('icms_sob_frete')"
          class="mt-2 col-md-4"
        >
          ICMS sob frete
        </mat-checkbox> -->
        <mat-checkbox
          color="primary"
          [formControl]="form.get('icms_sob_ipi')"
          class="mt-2 col-md-4"
        >
          ICMS sob IPI
        </mat-checkbox>
        <!-- FIXME: FOI OCULTADO ATÉ QUE SEJA DEFINIDO
        COMO SERA O PROCEDIMENTO DE ESTOQUE PARA NOTAS FISCAIS AVULSAS -->
        <!-- <mat-checkbox
          color="primary"
          [formControl]="form.get('nao_gera_receita')"
          class="mt-2 col-md-4"
        >
          Não gera receita
        </mat-checkbox>
        <mat-checkbox
          color="primary"
          [formControl]="form.get('nao_gera_estoque')"
          class="mt-2 col-md-4"
        >
          Não gera estoque
        </mat-checkbox> -->
      </div>
      <!-- Aliq. Propria -->
      <div class="content-allFormFields mb-2" *ngIf="!isInformativo">
        <!-- Aliq. propria -->
        <div class="content-formfields">
          <div [class]="returnClass()">
            <!-- <span class="p-float-label">
              <p-inputNumber
                [readonly]="isReadOnly"
                id="inputtext-valor"
                style="width: 100% !important;"
                [minFractionDigits]="2"
                [maxFractionDigits]="5"
                [inputStyleClass]="'input-filters text-right'"
                [formControl]="
                  !is101
                    ? form.get('aliq_especifica_icms')
                    : form.get('cred_sn')
                "
                inputId="percent"

                [required]="true"
              >
              </p-inputNumber>
              <label *ngIf="!is101" for="inputtext-valor"
                >Aliq. específica ICMS *</label
              >
              <label *ngIf="is101" for="inputtext-valor"
                >Crédito do Simples Nacional *</label
              >
            </span> -->
            <mat-form-field class="w-100" appearance="outline" floatLabel="always">
              <mat-label *ngIf="!is101" for="inputtext-valor"
                >Aliq. específica ICMS</mat-label
              >
              <mat-label *ngIf="is101" for="inputtext-valor"
                >Crédito do Simples Nacional</mat-label
              >
              <input
                class="text-right"
                matInput
                id="aliq_especifica_icms"
                [formControl]="
                  !is101
                    ? form.get('aliq_especifica_icms')
                    : form.get('cred_sn')
                "
                (keydown)="validateNumbers($event)"
              />
              <span matSuffix>%</span>
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                !is101 &&
                form.get('aliq_especifica_icms').touched &&
                form.get('aliq_especifica_icms').hasError('existSpecialChar')
              "
              innerHTML="Valor inválido, não aceita pontuação!"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                !is101 &&
                form.get('aliq_especifica_icms').touched &&
                form.get('aliq_especifica_icms').hasError('required')
              "
              [innerHTML]="'A aliq. especifica ICMS é obrigatória'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                !is101 &&
                form.get('aliq_especifica_icms').touched &&
                form.get('aliq_especifica_icms').hasError('before_split')
              "
              [innerHTML]="'Inválido: erro na parte inteira'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                !is101 &&
                form.get('aliq_especifica_icms').touched &&
                form.get('aliq_especifica_icms').hasError('after_split')
              "
              [innerHTML]="'Inválido: erro na parte decimal'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                !is101 &&
                form.get('aliq_especifica_icms').touched &&
                form.get('aliq_especifica_icms').hasError('errorComma')
              "
              [innerHTML]="'Inválido: excesso de virgulas'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                !is101 &&
                form.get('aliq_especifica_icms').touched &&
                form.get('aliq_especifica_icms').hasError('errorDots')
              "
              [innerHTML]="'Inválido: excesso de pontos'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                !is101 &&
                form.get('aliq_especifica_icms').touched &&
                form.get('aliq_especifica_icms').hasError('max_value')
              "
              [innerHTML]="'Inválido: passou dos limites'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                !is101 &&
                form.get('aliq_especifica_icms').touched &&
                form.get('aliq_especifica_icms').hasError('notNumbers')
              "
              [innerHTML]="'Inválido: insira um número'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                !is101 &&
                form.get('aliq_especifica_icms').touched &&
                form.get('aliq_especifica_icms').hasError('invalidNumber')
              "
              [innerHTML]="'Valor inválido'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                is101 &&
                form.get('cred_sn').touched &&
                form.get('cred_sn').hasError('required')
              "
              [innerHTML]="'Cŕedito Nacional não cadastrado no emitente'"
            >
            </small>
          </div>
          <div [class]="returnClass()" *ngIf="showAliqReducao || showST">
            <!-- <span class="p-float-label">
              <p-inputNumber
                id="inputtext-valor"
                style="width: 100% !important;"
                [minFractionDigits]="2"
                [maxFractionDigits]="5"
                [inputStyleClass]="'input-filters text-right'"
                [formControl]="
                  !showAliqReducao && showST
                    ? form.get('aliq_especifica_icms_st')
                    : form.get('aliq_reducao_base_icms')
                "
                inputId="percent"

              >
              </p-inputNumber>
              <label *ngIf="!(!showAliqReducao && showST)" for="inputtext-valor"
                >Aliq. redução base ICMS
                <span *ngIf="showRequiredReducao">*</span></label
              >
              <label *ngIf="!showAliqReducao && showST" for="inputtext-valor"
                >Aliq. especifíca ICMS ST
                <span *ngIf="requiredST">*</span></label
              >
            </span> -->
            <mat-form-field class="w-100" appearance="outline" floatLabel="always">
              <mat-label
                *ngIf="!(!showAliqReducao && showST)"
                for="inputtext-valor"
                >Aliq. redução base ICMS</mat-label
              >
              <mat-label
                *ngIf="!showAliqReducao && showST"
                for="inputtext-valor"
                >Aliq. especifíca ICMS ST</mat-label
              >
              <input
                class="text-right"
                matInput
                id="aliq_especifica_icms_st"
                [formControl]="
                  !showAliqReducao && showST
                    ? form.get('aliq_especifica_icms_st')
                    : form.get('aliq_reducao_base_icms')
                "
                (keydown)="validateNumbers($event)"
              />
              <span matSuffix>%</span>
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_icms').touched &&
                form
                  .get('aliq_reducao_base_icms')
                  .hasError('existSpecialChar') &&
                !(!showAliqReducao && showST)
              "
              innerHTML="Valor inválido, não aceita pontuação!"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_icms').touched &&
                form.get('aliq_reducao_base_icms').hasError('required') &&
                !(!showAliqReducao && showST)
              "
              [innerHTML]="'A aliq. redução base ICMS é obrigatória'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_icms').touched &&
                form.get('aliq_reducao_base_icms').hasError('before_split') &&
                !(!showAliqReducao && showST)
              "
              [innerHTML]="'Inválido: erro na parte inteira'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_icms').touched &&
                form.get('aliq_reducao_base_icms').hasError('after_split') &&
                !(!showAliqReducao && showST)
              "
              [innerHTML]="'Inválido: erro na parte decimal'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_icms').touched &&
                form.get('aliq_reducao_base_icms').hasError('errorComma') &&
                !(!showAliqReducao && showST)
              "
              [innerHTML]="'Inválido: excesso de virgulas'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_icms').touched &&
                form.get('aliq_reducao_base_icms').hasError('errorDots') &&
                !(!showAliqReducao && showST)
              "
              [innerHTML]="'Inválido: excesso de pontos'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_icms').touched &&
                form.get('aliq_reducao_base_icms').hasError('max_value') &&
                !(!showAliqReducao && showST)
              "
              [innerHTML]="'Inválido: passou dos limites'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_icms').touched &&
                form.get('aliq_reducao_base_icms').hasError('notNumbers') &&
                !(!showAliqReducao && showST)
              "
              [innerHTML]="'Inválido: insira um número'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_icms').touched &&
                form.get('aliq_reducao_base_icms').hasError('invalidNumber') &&
                !(!showAliqReducao && showST)
              "
              [innerHTML]="'Valor inválido'"
            >
            </small>

            <small
              class="p-error"
              *ngIf="
                form.get('aliq_especifica_icms_st').touched &&
                form
                  .get('aliq_especifica_icms_st')
                  .hasError('existSpecialChar') &&
                !showAliqReducao &&
                showST
              "
              innerHTML="Valor inválido, não aceita pontuação!"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_especifica_icms_st').touched &&
                form.get('aliq_especifica_icms_st').hasError('required') &&
                !showAliqReducao &&
                showST
              "
              [innerHTML]="'A aliq. especifica ICMS ST é obrigatória'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_especifica_icms_st').touched &&
                form.get('aliq_especifica_icms_st').hasError('before_split') &&
                !showAliqReducao &&
                showST
              "
              [innerHTML]="'Inválido: erro na parte inteira'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_especifica_icms_st').touched &&
                form.get('aliq_especifica_icms_st').hasError('after_split') &&
                !showAliqReducao &&
                showST
              "
              [innerHTML]="'Inválido: erro na parte decimal'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_especifica_icms_st').touched &&
                form.get('aliq_especifica_icms_st').hasError('errorComma') &&
                !showAliqReducao &&
                showST
              "
              [innerHTML]="'Inválido: excesso de virgulas'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_especifica_icms_st').touched &&
                form.get('aliq_especifica_icms_st').hasError('errorDots') &&
                !showAliqReducao &&
                showST
              "
              [innerHTML]="'Inválido: excesso de pontos'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_especifica_icms_st').touched &&
                form.get('aliq_especifica_icms_st').hasError('max_value') &&
                !showAliqReducao &&
                showST
              "
              [innerHTML]="'Inválido: passou dos limites'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_especifica_icms_st').touched &&
                form.get('aliq_especifica_icms_st').hasError('notNumbers') &&
                !showAliqReducao &&
                showST
              "
              [innerHTML]="'Inválido: insira um número'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_especifica_icms_st').touched &&
                form.get('aliq_especifica_icms_st').hasError('invalidNumber') &&
                !showAliqReducao &&
                showST
              "
              [innerHTML]="'Valor inválido'"
            >
            </small>
          </div>
          <!-- diferimento -->
          <div
            class="mt-2 col-md-4 mt-2"
            *ngIf="
              ((showAliqDiferimento || showST) && showAliqReducao) ||
              is201 ||
              is201_202_203
            "
          >
            <!-- <span class="p-float-label">
              <p-inputNumber
                [readonly]="isReadOnly201"
                id="inputtext-valor"
                style="width: 100% !important;"
                [minFractionDigits]="2"
                [maxFractionDigits]="5"
                [inputStyleClass]="'input-filters text-right'"
                [formControl]="
                  !showAliqDiferimento && showST && !is201
                    ? form.get('aliq_especifica_icms_st')
                    : is201
                    ? form.get('cred_sn')
                    : form.get('aliq_diferimento')
                "
                inputId="percent"

              >
              </p-inputNumber>
              <label
                *ngIf="!(!showAliqDiferimento && showST) && !is201"
                for="inputtext-valor"
                >Aliq. de diferimento *</label
              >
              <label
                *ngIf="!showAliqDiferimento && showST && !is201"
                for="inputtext-valor"
                >Aliq. especifíca ICMS ST
                <span *ngIf="requiredST">*</span></label
              >
              <label *ngIf="is201" for="inputtext-valor"
                >Crédito do Simples Nacional *</label
              >
            </span> -->
            <mat-form-field class="w-100" appearance="outline" floatLabel="always">
              <mat-label
                *ngIf="
                  !(!showAliqDiferimento && showST) && !is201 && !is201_202_203
                "
                for="inputtext-valor"
              >
                Aliq. de diferimento
              </mat-label>
              <mat-label
                *ngIf="
                  !showAliqDiferimento && showST && !is201 && !is201_202_203
                "
                for="inputtext-valor"
                >Aliq. especifíca ICMS ST
              </mat-label>
              <mat-label *ngIf="is201" for="inputtext-valor">
                Crédito do Simples Nacional
              </mat-label>
              <mat-label for="inputtext-valor" *ngIf="!is201 && is201_202_203">
                Aliq. redução base ST.
              </mat-label>
              <input
                class="text-right"
                matInput
                [readonly]="isReadOnly201"
                id="aliq_especifica_icms_st"
                [formControl]="
                  !showAliqDiferimento && showST && !is201 && !is201_202_203
                    ? form.get('aliq_especifica_icms_st')
                    : is201
                    ? form.get('cred_sn')
                    : is201_202_203
                    ? form.get('aliq_reducao_base_st')
                    : form.get('aliq_diferimento')
                "
                (keydown)="validateNumbers($event)"
              />
              <span matSuffix>%</span>
            </mat-form-field>

            <small
              class="p-error"
              *ngIf="
                form.get('aliq_diferimento').touched &&
                form.get('aliq_diferimento').hasError('existSpecialChar') &&
                !(!showAliqDiferimento && showST) &&
                !is201
              "
              innerHTML="Valor inválido, não aceita pontuação!"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_diferimento').touched &&
                form.get('aliq_diferimento').hasError('required') &&
                !(!showAliqDiferimento && showST) &&
                !is201
              "
              [innerHTML]="'A aliq. diferimento é obrigatória'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_diferimento').touched &&
                form.get('aliq_diferimento').hasError('before_split') &&
                !(!showAliqDiferimento && showST) &&
                !is201
              "
              [innerHTML]="'Inválido: erro na parte inteira'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_diferimento').touched &&
                form.get('aliq_diferimento').hasError('after_split') &&
                !(!showAliqDiferimento && showST) &&
                !is201
              "
              [innerHTML]="'Inválido: erro na parte decimal'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_diferimento').touched &&
                form.get('aliq_diferimento').hasError('errorComma') &&
                !(!showAliqDiferimento && showST) &&
                !is201
              "
              [innerHTML]="'Inválido: excesso de virgulas'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_diferimento').touched &&
                form.get('aliq_diferimento').hasError('errorDots') &&
                !(!showAliqDiferimento && showST) &&
                !is201
              "
              [innerHTML]="'Inválido: excesso de pontos'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_diferimento').touched &&
                form.get('aliq_diferimento').hasError('max_value') &&
                !(!showAliqDiferimento && showST) &&
                !is201
              "
              [innerHTML]="'Inválido: passou dos limites'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_diferimento').touched &&
                form.get('aliq_diferimento').hasError('notNumbers') &&
                !(!showAliqDiferimento && showST) &&
                !is201
              "
              [innerHTML]="'Inválido: insira um número'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_diferimento').touched &&
                form.get('aliq_diferimento').hasError('invalidNumber') &&
                !(!showAliqDiferimento && showST) &&
                !is201
              "
              [innerHTML]="'Valor inválido'"
            >
            </small>

            <small
              class="p-error"
              *ngIf="
                form.get('aliq_especifica_icms_st').touched &&
                form
                  .get('aliq_especifica_icms_st')
                  .hasError('existSpecialChar') &&
                !showAliqDiferimento &&
                showST &&
                !is201
              "
              innerHTML="Valor inválido, não aceita pontuação!"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_especifica_icms_st').touched &&
                form.get('aliq_especifica_icms_st').hasError('required') &&
                !showAliqDiferimento &&
                showST &&
                !is201
              "
              [innerHTML]="'A aliq. especifica ICMS ST é obrigatória'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_especifica_icms_st').touched &&
                form.get('aliq_especifica_icms_st').hasError('before_split') &&
                !showAliqDiferimento &&
                showST &&
                !is201
              "
              [innerHTML]="'Inválido: erro na parte inteira'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_especifica_icms_st').touched &&
                form.get('aliq_especifica_icms_st').hasError('after_split') &&
                !showAliqDiferimento &&
                showST &&
                !is201
              "
              [innerHTML]="'Inválido: erro na parte decimal'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_especifica_icms_st').touched &&
                form.get('aliq_especifica_icms_st').hasError('errorComma') &&
                !showAliqDiferimento &&
                showST &&
                !is201
              "
              [innerHTML]="'Inválido: excesso de virgulas'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_especifica_icms_st').touched &&
                form.get('aliq_especifica_icms_st').hasError('errorDots') &&
                !showAliqDiferimento &&
                showST &&
                !is201
              "
              [innerHTML]="'Inválido: excesso de pontos'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_especifica_icms_st').touched &&
                form.get('aliq_especifica_icms_st').hasError('max_value') &&
                !showAliqDiferimento &&
                showST &&
                !is201
              "
              [innerHTML]="'Inválido: passou dos limites'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_especifica_icms_st').touched &&
                form.get('aliq_especifica_icms_st').hasError('notNumbers') &&
                !showAliqDiferimento &&
                showST &&
                !is201
              "
              [innerHTML]="'Inválido: insira um número'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_especifica_icms_st').touched &&
                form.get('aliq_especifica_icms_st').hasError('invalidNumber') &&
                !showAliqDiferimento &&
                showST &&
                !is201
              "
              [innerHTML]="'Valor inválido'"
            >
            </small>

            <small
              class="p-error"
              *ngIf="
                form.get('cred_sn').touched &&
                form.get('cred_sn').hasError('required') &&
                is201
              "
              [innerHTML]="'Cŕedito Nacional não cadastrado no emitente'"
            >
            </small>
          </div>
          <div
            class="mt-2 col-md-4 mt-2"
            *ngIf="
              !showAliqDiferimento &&
              !showAliqReducao &&
              showST &&
              showAliqReducaoST
            "
          >
            <!-- <span class="p-float-label">
              <p-inputNumber
                id="inputtext-valor"
                style="width: 100% !important;"
                [minFractionDigits]="2"
                [maxFractionDigits]="5"
                [inputStyleClass]="'input-filters text-right'"
                [formControl]="form.get('aliq_reducao_base_st')"
                inputId="percent"

              >
              </p-inputNumber>
              <label for="inputtext-valor"
                >Aliq. redução base ST.
                <span *ngIf="showRequiredReducaoST">*</span></label
              >
            </span> -->
            <mat-form-field class="w-100" appearance="outline" floatLabel="always">
              <mat-label for="inputtext-valor">
                Aliq. redução base ST.
              </mat-label>
              <input
                class="text-right"
                matInput
                id="aliq_reducao_base_st"
                [formControl]="form.get('aliq_reducao_base_st')"
                (keydown)="validateNumbers($event)"
              />
              <span matSuffix>%</span>
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_st').touched &&
                form.get('aliq_reducao_base_st').hasError('existSpecialChar')
              "
              innerHTML="Valor inválido, não aceita pontuação!"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_st').touched &&
                form.get('aliq_reducao_base_st').hasError('required')
              "
              [innerHTML]="'A aliq. redução base ST é obrigatória'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_st').touched &&
                form.get('aliq_reducao_base_st').hasError('before_split')
              "
              [innerHTML]="'Inválido: erro na parte inteira'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_st').touched &&
                form.get('aliq_reducao_base_st').hasError('after_split')
              "
              [innerHTML]="'Inválido: erro na parte decimal'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_st').touched &&
                form.get('aliq_reducao_base_st').hasError('errorComma')
              "
              [innerHTML]="'Inválido: excesso de virgulas'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_st').touched &&
                form.get('aliq_reducao_base_st').hasError('errorDots')
              "
              [innerHTML]="'Inválido: excesso de pontos'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_st').touched &&
                form.get('aliq_reducao_base_st').hasError('max_value')
              "
              [innerHTML]="'Inválido: passou dos limites'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_st').touched &&
                form.get('aliq_reducao_base_st').hasError('notNumbers')
              "
              [innerHTML]="'Inválido: insira um número'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_st').touched &&
                form.get('aliq_reducao_base_st').hasError('invalidNumber')
              "
              [innerHTML]="'Valor inválido'"
            >
            </small>
          </div>
        </div>
      </div>
      <!-- Aliq. ST -->
      <div
        class="content-allFormFields mb-2"
        *ngIf="!isInformativo && (is70 || is900 || is90 || is201_202_203)"
      >
        <div class="content-formfields">
          <div class="mt-2 col-md-4 mt-2" *ngIf="is201">
            <!-- <span class="p-float-label">
              <p-inputNumber
                id="inputtext-valor"
                style="width: 100% !important;"
                [minFractionDigits]="2"
                [maxFractionDigits]="5"
                [inputStyleClass]="'input-filters text-right'"
                [formControl]="form.get('aliq_reducao_base_st')"
                inputId="percent"

              >
              </p-inputNumber>
              <label for="inputtext-valor"
                >Aliq. redução base ST.
                <span *ngIf="showRequiredReducaoST">*</span></label
              >
            </span> -->
            <mat-form-field class="w-100" appearance="outline" floatLabel="always">
              <mat-label for="inputtext-valor">
                Aliq. redução base ST
              </mat-label>
              <input
                class="text-right"
                matInput
                id="aliq_reducao_base_st"
                [formControl]="form.get('aliq_reducao_base_st')"
                (keydown)="validateNumbers($event)"
              />
              <span matSuffix>%</span>
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_st').touched &&
                form.get('aliq_reducao_base_st').hasError('existSpecialChar')
              "
              innerHTML="Valor inválido, não aceita pontuação!"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('aliq_reducao_base_st').touched &&
                form.get('aliq_reducao_base_st').hasError('required')
              "
              [innerHTML]="'A aliq. redução base ST é obrigatória'"
            >
            </small>
          </div>

          <div class="mt-2 col-md-4 mt-2">
            <!-- <span class="p-float-label">
              <p-inputNumber
                id="inputtext-valor" style="width: 100% !important;"
                [minFractionDigits]="2" [maxFractionDigits]="5"
                [inputStyleClass]="'input-filters text-right'"
                [formControl]="form.get('aliq_reducao_base_st')"
                inputId="percent"  >
              </p-inputNumber>
              <label for="inputtext-valor">Aliq. redução base ST. <span *ngIf="showRequiredReducaoST">*</span></label>
            </span> -->
            <mat-form-field class="w-100" appearance="outline" floatLabel="always">
              <mat-label for="inputtext-valor">
                {{
                  is70 || is90
                    ? 'Aliq. redução base ST'
                    : 'Aliq. redução base ICMS'
                }}
              </mat-label>
              <input
                class="text-right"
                matInput
                id="aliq_reducao_base_icms"
                [formControl]="
                  is70 || is90
                    ? form.get('aliq_reducao_base_st')
                    : form.get('aliq_reducao_base_icms')
                "
                (keydown)="validateNumbers($event)"
              />
              <span matSuffix>%</span>
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                !is70 &&
                !is90 &&
                form.get('aliq_reducao_base_icms').touched &&
                form.get('aliq_reducao_base_icms').hasError('existSpecialChar')
              "
              innerHTML="Valor inválido, não aceita pontuação!"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                !is70 &&
                !is90 &&
                form.get('aliq_reducao_base_icms').touched &&
                form.get('aliq_reducao_base_icms').hasError('required')
              "
              [innerHTML]="'A aliq. redução base é obrigatória'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                !is70 &&
                !is90 &&
                form.get('aliq_reducao_base_icms').touched &&
                form.get('aliq_reducao_base_icms').hasError('before_split')
              "
              [innerHTML]="'Inválido: erro na parte inteira'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                !is70 &&
                !is90 &&
                form.get('aliq_reducao_base_icms').touched &&
                form.get('aliq_reducao_base_icms').hasError('after_split')
              "
              [innerHTML]="'Inválido: erro na parte decimal'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                !is70 &&
                !is90 &&
                form.get('aliq_reducao_base_icms').touched &&
                form.get('aliq_reducao_base_icms').hasError('errorComma')
              "
              [innerHTML]="'Inválido: excesso de virgulas'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                !is70 &&
                !is90 &&
                form.get('aliq_reducao_base_icms').touched &&
                form.get('aliq_reducao_base_icms').hasError('errorDots')
              "
              [innerHTML]="'Inválido: excesso de pontos'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                !is70 &&
                !is90 &&
                form.get('aliq_reducao_base_icms').touched &&
                form.get('aliq_reducao_base_icms').hasError('max_value')
              "
              [innerHTML]="'Inválido: passou dos limites'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                !is70 &&
                !is90 &&
                form.get('aliq_reducao_base_icms').touched &&
                form.get('aliq_reducao_base_icms').hasError('notNumbers')
              "
              [innerHTML]="'Inválido: insira um número'"
            >
            </small>
            <small
              class="p-error"
              *ngIf="
                !is70 &&
                !is90 &&
                form.get('aliq_reducao_base_icms').touched &&
                form.get('aliq_reducao_base_icms').hasError('invalidNumber')
              "
              [innerHTML]="'Valor inválido'"
            >
            </small>
          </div>
        </div>
      </div>
    </div>

    <div
      style="margin-top: 14px;"
      class="w-100 d-flex justify-content-between justify-content-md-start align-items-center"
    >
      <button
        type="button"
        class="mr-md-2"
        mat-stroked-button
        id="cancel-btn"
        [matDialogClose]="undefined"
        [disabled]="loading"
      >
        Cancelar
      </button>
      <button
        id="save-btn"
        mat-raised-button
        color="primary"
        (click)="onSubmit()"
        [disabled]="!form.valid || loading"
      >
        Salvar
      </button>
    </div>
  </mat-card-content>
</mat-card>
